import { Text } from '@fluentui/react'
import React from 'react'
import { Link } from 'react-router-dom'
import styles from 'styles/components/pages/index/homeNote.module.scss'

/**
 * @param {object} props Props
 * @param {Partial<import('history').Location> | string} props.to to
 * @param {React.ReactNode} props.children children
 * @returns {JSX.Element} Returns
 */
export default function HomeNote({
    to, children,
}) {
    if (to)
        return (
            <Link to={to}>
                <div className={styles['home-note']}>
                    <Text>
                        {children}
                    </Text>
                </div>
            </Link>
        )

    return (
        <div className={styles['home-note']}>
            <Text>
                {children}
            </Text>
        </div>
    )
}
